
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/treatments/[slug]",
      function () {
        return require("private-next-pages/treatments/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/treatments/[slug]"])
      });
    }
  